// src/components/BusinessPage.jsx
import React from "react";
import { useEffect } from 'react';
import Header from "./Header";
import Footer from "./Footer";

const BusinessPage = ({ setCurrentPage }) => {
   useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' }); // 可选：平滑滚动
  }, []);
  return (
    <div>
      <Header currentPage="business" setCurrentPage={setCurrentPage} />

      <main className="pt-28 pb-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-20">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">核心业务</h2>
            <div className="w-32 h-1 bg-gradient-to-r from-blue-600 via-purple-600 to-emerald-600 mx-auto rounded-full"></div>
            <p className="mt-6 text-xl text-gray-600 max-w-3xl mx-auto">
              公司业务涵盖设备制造与销售、能源技术服务、综合能源服务、投资与运营四大领域，为客户提供全方位新能源解决方案。
            </p>
          </div>

          <div className="space-y-16">
            {/* 设备制造与销售 —— 4列布局 */}
            <div className="bg-gradient-to-br from-orange-50 via-amber-50 to-yellow-50 rounded-3xl shadow-xl p-8 md:p-10 border border-amber-100">
              <div className="flex items-center mb-8">
                <div className="w-14 h-14 bg-orange-500 rounded-2xl flex items-center justify-center mr-5">
                  <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z" />
                  </svg>
                </div>
                <h3 className="text-3xl font-bold text-gray-900">设备制造与销售</h3>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
                <BusinessItem
                  title="太阳能光伏发电站"
                  desc="专注于太阳能光伏电站投资建设与运维，提供高效能的太阳能解决方案。从项目规划、设计、建设到后期运维，提供一站式服务。"
                  points={[
                    "大型地面光伏电站建设：利用荒山、荒地等资源，建设兆瓦级光伏电站",
                    "工商业分布式光伏项目：为企业屋顶提供光伏解决方案，降低用电成本",
                    "户用光伏系统解决方案：为家庭用户提供清洁能源，实现自发自用",
                    "光伏电站运维服务：提供专业运维团队，确保电站高效稳定运行",
                  ]}
                  bulletColor="bg-orange-500"
                />
                <BusinessItem
                  title="风力发电设备"
                  desc="销售先进的风力发电设备，助力风能资源的开发和利用，推动绿色能源发展。设备适应云南高原特殊气候条件。"
                  points={[
                    "高原型风力发电机组：专为云南高原地区设计，适应低气压、强紫外线环境",
                    "风电场配套设备：包括塔筒、叶片、控制系统等全套设备",
                    "风电设备维护服务：提供定期检修、故障处理、性能优化等服务",
                    "风电技术咨询服务：提供风电场选址、风资源评估等专业服务",
                  ]}
                  bulletColor="bg-orange-500"
                />
                <BusinessItem
                  title="储能系统集成"
                  desc="提供完整的储能系统解决方案，包括电池组、管理系统等，满足不同规模储能需求。应用于电网调峰、工商业储能等领域。"
                  points={[
                    "电化学储能系统：采用锂离子电池、磷酸铁锂电池等先进技术",
                    "储能电站建设：从方案设计到施工安装，提供EPC总承包服务",
                    "家庭储能解决方案：为家庭用户提供备用电源和峰谷套利",
                    "储能系统运维：提供远程监控、数据分析、预防性维护等服务",
                  ]}
                  bulletColor="bg-orange-500"
                />
                <BusinessItem
                  title="智能电网设备"
                  desc="涉足智能电网设备的制造与销售，为构建高效、稳定的智能电网提供支持。产品包括智能电表、配电自动化设备等。"
                  points={[
                    "智能电表及采集系统：实现用电数据的实时采集和远程传输",
                    "配电自动化设备：提高配电网的自动化水平和故障处理能力",
                    "能源管理系统：实现能源的精细化管理和优化调度",
                    "微电网控制系统：实现分布式能源的协调控制和优化运行",
                  ]}
                  bulletColor="bg-orange-500"
                />
              </div>
            </div>

            {/* 能源技术服务 —— 2列布局 */}
            <div className="bg-gradient-to-br from-teal-50 via-cyan-50 to-emerald-50 rounded-3xl shadow-xl p-8 md:p-10 border border-teal-100">
              <div className="flex items-center mb-8">
                <div className="w-14 h-14 bg-teal-500 rounded-2xl flex items-center justify-center mr-5">
                  <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
                  </svg>
                </div>
                <h3 className="text-3xl font-bold text-gray-900">能源技术服务</h3>
              </div>
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                <BusinessItem
                  title="可再生能源咨询"
                  desc="为客户提供太阳能、风能、储能电站等可再生能源项目的可行性研究和咨询服务，帮助客户评估项目投资价值。"
                  points={[
                    "项目可行性研究报告：包括技术方案、经济分析、环境影响评估等",
                    "技术方案设计咨询：根据客户需求定制最优技术方案",
                    "政策法规咨询服务：解读国家和地方新能源政策，指导项目申报",
                    "项目融资咨询服务：协助客户设计融资方案，对接金融机构",
                  ]}
                  bulletColor="bg-teal-500"
                />
                <BusinessItem
                  title="能源效率评估"
                  desc="通过专业工具和方法，评估企业能源使用效率，提出节能减排的优化方案，帮助企业降低能源成本。"
                  points={[
                    "能源审计服务：全面评估企业能源使用情况，识别节能潜力",
                    "节能潜力评估：量化节能空间，制定节能目标和实施计划",
                    "节能改造方案设计：提供技术改造方案，包括设备更新、系统优化等",
                    "节能效果评估：改造后评估节能效果，确保投资回报",
                  ]}
                  bulletColor="bg-teal-500"
                />
              </div>
            </div>

            {/* 综合能源服务 —— 3项，用 1列（md:2, lg:3） */}
            <div className="bg-gradient-to-br from-indigo-50 via-blue-50 to-sky-50 rounded-3xl shadow-xl p-8 md:p-10 border border-indigo-100">
              <div className="flex items-center mb-8">
                <div className="w-14 h-14 bg-indigo-500 rounded-2xl flex items-center justify-center mr-5">
                  <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                  </svg>
                </div>
                <h3 className="text-3xl font-bold text-gray-900">综合能源服务</h3>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                <BusinessItem
                  title="能源管理咨询"
                  desc="提供能源审计、节能评估等咨询服务，助力企业优化能源使用，降低运营成本。定制化能源管理解决方案。"
                  points={[
                    "企业能源管理体系建立：帮助企业建立ISO50001能源管理体系",
                    "能源成本分析与优化：分析能源成本结构，提出优化建议",
                    "碳排放管理咨询：帮助企业核算碳排放，制定碳减排方案",
                    "能源采购策略优化：优化能源采购渠道和方式，降低采购成本",
                  ]}
                  bulletColor="bg-indigo-500"
                />
                <BusinessItem
                  title="分布式能源系统"
                  desc="开发和维护分布式能源系统，如太阳能光伏、风能等，为客户提供绿色能源解决方案，提高能源自给率。"
                  points={[
                    "工业园区分布式能源：为工业园区提供综合能源解决方案",
                    "商业综合体能源系统：为商场、酒店等提供冷热电联供系统",
                    "微电网系统建设：构建独立运行的微电网系统，提高供电可靠性",
                    "多能互补系统：整合多种能源形式，实现能源的优化配置",
                  ]}
                  bulletColor="bg-indigo-500"
                />
                <BusinessItem
                  title="能源效率提升"
                  desc="通过技术升级和设备改造，提高能源使用效率，减少能源浪费，实现可持续发展。提供一站式节能改造服务。"
                  points={[
                    "照明系统节能改造：采用LED照明和智能控制系统",
                    "空调系统优化：采用高效空调设备和智能温控系统",
                    "电机系统能效提升：采用高效电机和变频控制技术",
                    "余热余压利用：回收工业生产过程中的余热余压",
                  ]}
                  bulletColor="bg-indigo-500"
                />
              </div>
            </div>

            {/* 投资与运营 —— 2列 */}
            <div className="bg-gradient-to-br from-rose-50 via-pink-50 to-fuchsia-50 rounded-3xl shadow-xl p-8 md:p-10 border border-rose-100">
              <div className="flex items-center mb-8">
                <div className="w-14 h-14 bg-rose-500 rounded-2xl flex items-center justify-center mr-5">
                  <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                </div>
                <h3 className="text-3xl font-bold text-gray-900">投资与运营</h3>
              </div>
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                <BusinessItem
                  title="新能源项目投资"
                  desc="专注于风能、太阳能等新能源项目的投资与开发，采用多种投资模式，包括独资、合资、合作开发等。"
                  points={[
                    "光伏电站项目投资：投资建设大型地面光伏电站和分布式光伏项目",
                    "风电场项目投资：投资建设高原风电场，开发风能资源",
                    "储能项目投资：投资建设电网侧和用户侧储能项目",
                    "综合能源项目投资：投资建设多能互补的综合能源项目",
                  ]}
                  bulletColor="bg-rose-500"
                />
                <BusinessItem
                  title="运营管理服务"
                  desc="提供全面的运营管理服务，确保新能源项目高效、稳定地运行。包括日常运维、设备管理、安全管理等。"
                  points={[
                    "电站日常运维管理：包括设备巡检、数据监控、故障处理等",
                    "设备预防性维护：定期进行设备维护，延长设备使用寿命",
                    "安全生产管理：建立安全管理体系，确保项目安全运行",
                    "绩效考核与优化：建立绩效考核体系，持续优化运营管理",
                  ]}
                  bulletColor="bg-rose-500"
                />
              </div>
            </div>

            {/* 战略发展方向 —— 仅微调样式 */}
            <div className="bg-gradient-to-r from-gray-900 via-blue-900 to-emerald-900 rounded-3xl p-10 md:p-12 text-white relative overflow-hidden">
              <div className="absolute inset-0 bg-black opacity-20"></div>
              <div className="relative z-10">
                <h3 className="text-3xl font-bold text-white mb-8 text-center">战略发展方向</h3>
                <div className="grid md:grid-cols-3 gap-8">
                  <StrategyItem
                    title="轻资产模式"
                    desc="专注核心竞争力，灵活资本运作，优化供应链管理，提高运营效率"
                    points={["外包非核心业务", "强化市场开发与技术创新", "优化供应链管理", "降低财务风险"]}
                    color="bg-blue-500"
                  />
                  <StrategyItem
                    title="区域布局"
                    desc="聚焦云南本土市场，拓展西南地区合作，探索一带一路沿线市场"
                    points={["利用云南丰富资源", "实现资源共享", "开拓国际市场", "建立区域合作"]}
                    color="bg-emerald-500"
                  />
                  <StrategyItem
                    title="碳中和目标"
                    desc="开发可再生能源项目，推动绿色交通与物流，助力实现碳中和"
                    points={["减少碳排放", "使用电动车辆", "低碳运输方式", "环保技术创新"]}
                    color="bg-purple-500"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>

      <Footer currentPage="business" setCurrentPage={setCurrentPage} />
    </div>
  );
};

// 通用业务子项组件（保留所有原始内容）
const BusinessItem = ({ title, desc, points, bulletColor }) => (
  <div>
    <h4 className="text-xl font-bold text-gray-900 mb-3">{title}</h4>
    <p className="text-gray-700 text-base leading-relaxed mb-4">{desc}</p>
    <ul className="space-y-2 text-gray-700">
      {points.map((point, idx) => (
        <li key={idx} className="flex items-start">
          <span className={`w-2 h-2 ${bulletColor} rounded-full mt-2.5 mr-3 flex-shrink-0`}></span>
          <span className="text-base">{point}</span>
        </li>
      ))}
    </ul>
  </div>
);

// 战略子项
const StrategyItem = ({ title, desc, points, color }) => (
  <div className="text-center">
    <div className={`w-14 h-14 ${color} rounded-2xl flex items-center justify-center mx-auto mb-4`}>
      <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
      </svg>
    </div>
    <h4 className="text-xl font-semibold text-white mb-2">{title}</h4>
    <p className="text-blue-100 text-sm mb-3">{desc}</p>
    <ul className="text-left space-y-1 text-xs text-blue-100">
      {points.map((p, i) => (
        <li key={i}>• {p}</li>
      ))}
    </ul>
  </div>
);

export default BusinessPage;